<template lang="html">
  <div id="floorplans-page" class="flex">
    <scale-model class="fixed w-0 w-50-m w-40-l vh-100" v-if="windowWidth > 767"/>
    <div class="w-0 w-50-ns w-40-l" v-if="windowWidth > 767"></div>
    <transition name="fade" mode="out-in">
      <router-view class="w-100 w-50-m w-60-l" v-if="!viewingFavoritesList" />
      <floorplan-favourites class="w-100 w-50-m w-60-l" v-else />
    </transition>

    <transition name="fade" mode="out-in">
      <email-floorplan v-show="emailModal" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EmailFloorplanComponent from '@/components/EmailFloorplan';
import ScaleModelComponent from './ScaleModel';
import FloorplanFavourites from './FloorplanFavourites/FloorplanFavourites';

export default {
  name: 'floorplans-page',
  components: {
    'scale-model': ScaleModelComponent,
    'floorplan-favourites': FloorplanFavourites,
    'email-floorplan': EmailFloorplanComponent
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapGetters({
      emailModal: 'showEmailModal',
      modelIsReady: 'getModelReady',
      favourites: 'favourites',
      favouritesMode: 'favouritesMode',
      viewingFavoritesList: 'viewingFavoritesList',
      getPlan: 'getFloorplanById',
      getUnitsShown: 'getUnitsShown'
    })
  },
  methods: {
    ...mapActions({
      SELECT_PLAN: 'SELECT_PLAN',
      CLEAR_UNITS: 'CLEAR_UNITS',
      setUnitsShown: 'SET_UNITS_SHOWN',
      TOGGLE_KEYPLATE_SHOWN: 'TOGGLE_KEYPLATE_SHOWN',
      REAPPLY_LAST_ACTION: 'REAPPLY_LAST_ACTION',
      FILTER_UNITS: 'FILTER_UNITS',
      SET_ACTIVE_FP_PAGE: 'SET_ACTIVE_FP_PAGE',
      resetView: 'RESET_VIEW',
      setModelReady: 'SET_MODEL_READY',
      SET_DIR: 'SET_DIR'
    }),
    modelReady() {
      setTimeout(() => {
        this.setModelReady();
        this.CLEAR_UNITS();

        if (this.$route.name === 'FloorplanDetail') {
          this.goToPlan();
        } else {
          this.viewFilteredUnits();
          this.CLEAR_UNITS();
        }
      }, 50, this);

      document.querySelector('iframe[name="model"]').style.opacity = '0';
      document.querySelector('iframe[name="model"]').style.width = '0';
      setTimeout(() => {
        document.querySelector('iframe[name="model"]').style.width = '100%';
        document.querySelector('iframe[name="model"]').style.opacity = '1';
      }, 750);
    },
    goToPlan() {
      if (this.modelIsReady) {
        const targPlan = this.getPlan(this.$route.params.id);
        this.CLEAR_UNITS();
        this.SELECT_PLAN(targPlan.current);
        this.SET_ACTIVE_FP_PAGE(this.$route.name);
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    viewFavouriteUnits() {
      this.TOGGLE_KEYPLATE_SHOWN(false);
      if (this.getUnitsShown) {
        this.CLEAR_UNITS();

        const favouriteUnits =
          this.favourites.reduce((n, plan) => { n.push(...plan.stacks); return n; }, [])
            .reduce((n, stack) => { n.push(...stack.suites); return n; }, [])
            .filter(suite => suite.status === 'available')
            .map(suite => suite.name);

        this.FILTER_UNITS(favouriteUnits);
        this.SET_DIR({ dir: this.favourites[0].exposure.join(''), distance: 150 });
      }
    },
    viewFilteredUnits() {
      // Floorplan list
      this.TOGGLE_KEYPLATE_SHOWN(false);
      // restore last filtered units
      if (this.getUnitsShown) {
        this.REAPPLY_LAST_ACTION(this.$route.name);
        this.resetView();
      }
    }
  },
  created() {
    if (!window.modelReady) {
      window.modelReady = this.modelReady.bind(this);
    }
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.name === 'FloorplanDetail') {
      this.goToPlan();
    } else if (this.favouritesMode) {
      if (this.favourites.length > 0) {
        this.viewFavouriteUnits();
      }
    } else {
      this.viewFilteredUnits();
    }
  }
};
</script>

<style lang="scss">
#floorplans-page {

}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplansPage.vue